module.exports = __webpack_public_path__ + "img/email-verification-icon.05f1c04f.svg";